import store from './store';

export const UserRole = {
  Admin: 'Admin',
  Doctor: 'Doctor',
  FrontDesk: 'Front Desk',
  Patient: 'Patient',
} as const;

export type TUserRole = (typeof UserRole)[keyof typeof UserRole];

export type TUserAuthInfo = {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  hospitalId: number | null;
  email: string;
  role: TUserRole;
  mobileNumber: string | null;
  profile_url: string | null;
  timezone: string | null;
  patientPlatformFirstLogin: boolean;
};

export type TRootState = ReturnType<typeof store.getState>;
export type TAppDispatch = typeof store.dispatch;
